import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';

import { submit, isSubmitting } from 'redux-form';

import Button from 'components/common/Button';

import DiagnosesAddForm from './DiagnosesAddForm';

const styles = () => ({
  form: {
    padding: '35px 40px',
  },
});

const DiagnosesAddDialog = props => (
  <Dialog
    open={props.open}
    onClose={props.onClose}
    maxWidth="sm"
  >
    <DialogTitle>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        Diagnoses
      </Typography>
    </DialogTitle>
    <DialogContent>
      <DiagnosesAddForm
        className={props.classes.form}
        onSubmitSuccess={(values) => {
          props.onSubmitSuccess(values);
        }}
        variant="dialog"
        formValues={props.formValues}
      />
    </DialogContent>
    <DialogActions>
      <Button
        onClick={props.onClose}
        variant="raised"
      >
        Cancel
      </Button>
      <Button
        onClick={() => props.actions.submit('patientDiagnosesAdd')}
        variant="raised"
        color="primary"
        disabled={props.submitting}
      >
        Done
      </Button>
    </DialogActions>
  </Dialog>
);

DiagnosesAddDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmitSuccess: PropTypes.func,
  submitting: PropTypes.bool.isRequired,
  actions: PropTypes.shape({
    submit: PropTypes.func.isRequired,
  }).isRequired,
  formValues: PropTypes.shape({
    'Primary Insurance ID': PropTypes.number,
  }),
  classes: PropTypes.shape({
    form: PropTypes.string.isRequired,
  }).isRequired,
};

DiagnosesAddDialog.defaultProps = {
  open: false,
  onClose: () => {},
  onSubmitSuccess: () => {},
  formValues: {},
};

const mapStateToProps = store => ({
  submitting: isSubmitting('patientDiagnosesAdd')(store),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ submit }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(DiagnosesAddDialog),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Diagnoses/DiagnosesAddDialog.js